const ACTIVE = "Actief";
const NOT_ACTIVE = "Niet actief";

const CUSTOM = "Aangepast";
const NOT_CUSTOM = "Niet aangepast";

const ALL = "Alle";

const CREATED = "Aangemaakt";
const CREDIT_NOTED = "Gecrediteerd";

const CONFIRMED = "Bevestigd";
const MAILED = "Verstuurd";
const NOT_CONFIRMED = "Niet bevestigd";


export default {
    ACTIVE,
    NOT_ACTIVE,
    CUSTOM,
    NOT_CUSTOM,
    ALL,
    CREATED,
    CREDIT_NOTED,
    CONFIRMED,
    NOT_CONFIRMED,
    MAILED
};

export const ActivityStatusList = [ACTIVE, NOT_ACTIVE, ALL];
export const AbsenceTypeList = [CUSTOM, NOT_CUSTOM, ALL];
export const InvoiceStatusList = [ALL, CREATED, CONFIRMED,CREDIT_NOTED,MAILED];
export const ConfirmedEmailStatusList = [ALL, CONFIRMED, NOT_CONFIRMED];
